import styled from "styled-components";

export const Container = styled.section`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 100%;
  margin: 0 0 1.5rem;
`;

export const WrapperImage = styled.div`
  width: 100%;
  margin: 0 1rem 0 0;
  max-width: 10rem;

  border-radius: 0.5rem;

  img {
    border-radius: 0.5rem;
  }
`;

export const WrapperText = styled.div`
  width: 100%;
`;

export const Title = styled.h1`
  margin: 0;

  font-family: Inter;
  font-size: 1.25rem;
  font-weight: 700;
  line-height: 1.5rem;

  color: ${({ theme }) => theme.checkoutOnePage?.textColor};

  @media (max-width: 450px) {
    font-family: Inter;
    font-size: 1rem;
    font-weight: 700;
    line-height: 1.25rem;
  }
`;

export const SubTitle = styled.p`
  margin: 0.5rem 0 0;

  font-family: Inter;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.25rem;

  color: ${({ theme }) => theme.checkoutOnePage?.textColor};

  @media (max-width: 450px) {
    font-family: Inter;
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.125rem;
  }
`;
